import { useKanagawaPalette } from '@aid/theme';

/**
 * Placeholders matching the v3 App Hub card shape (16/10 artwork block on
 * top, solid accent block below). Used by the catalog loading state and the
 * initial keycloak LoadingScreen so the hub never flashes a generic spinner.
 */

function shimmerBar(width: number | string, height: number, radius = 8, background?: string) {
  const palette = useKanagawaPalette();
  return (
    <span
      className="hub-shimmer"
      style={{
        width,
        height,
        borderRadius: radius,
        background: background ?? palette.surface1,
        flex: 'none',
      }}
    />
  );
}

function AppCardSkeleton({ accent }: { accent: string }) {
  const palette = useKanagawaPalette();
  const shimmer = 'rgba(255, 255, 255, 0.22)';

  return (
    <div
      className="hub-card hub-skeleton"
      style={{
        background: palette.surface0,
        border: `1px solid ${palette.surface1}`,
        borderRadius: 20,
      }}
    >
      <div className="hub-card__art" style={{ background: palette.surface1 }}>
        <span className="hub-shimmer" style={{ display: 'block', width: '100%', height: '100%' }} />
      </div>
      <div className="hub-card__accent" style={{ background: accent, color: '#FFFFFF' }}>
        {shimmerBar('42%', 24, 8, shimmer)}
        {shimmerBar('30%', 14, 7, shimmer)}
        {shimmerBar('68%', 12, 6, shimmer)}
        <span
          className="hub-shimmer"
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            background: shimmer,
            flex: 'none',
            marginTop: 'auto',
          }}
        />
      </div>
    </div>
  );
}

export function HeroCardSkeleton() {
  const palette = useKanagawaPalette();
  return <AppCardSkeleton accent={palette.blue} />;
}

export function StandardCardSkeleton() {
  const palette = useKanagawaPalette();
  return <AppCardSkeleton accent={palette.green} />;
}
